import CategoriesProcessorsNavigation from "./CategoriesProcessorsNavigation";

export default CategoriesProcessorsNavigation;
